import LeadService from '../../services/LeadService';
import leadUseCase from './leadUseCase';

const leadFactory = leadUseCase({ LeadService: LeadService() });

export default leadFactory;
